import { Checkbox, InputNumber } from 'antd';
import { MONEY_MAX, moneyFormatter, moneyParser, moneyInputKeyDownGuard } from '../../utils/moneyInput';

export interface InsuranceValue {
  enabled: boolean;
  /** `undefined` = đã tick nhưng chưa nhập. Không tự điền tiền hàng: khai giá là quyết định của người bán. */
  amount?: number;
}

interface Props {
  value: InsuranceValue;
  onChange: (v: InsuranceValue) => void;
  /** Bật sau khi bấm tạo đơn. */
  hasError?: boolean;
  /** Chỉ xem — màn sửa đơn hiện đúng khối này cho đơn đã chốt giỏ. */
  disabled?: boolean;
}

export function InsuranceField({ value, onChange, hasError, disabled }: Props): JSX.Element {
  const missing = hasError && value.enabled && !(value.amount && value.amount > 0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Checkbox
          aria-label="Đơn hàng có bảo hiểm"
          disabled={disabled}
          checked={value.enabled}
          onChange={(e) => onChange({ enabled: e.target.checked, amount: undefined })}
        >
          <span style={{ fontSize: 12 }}>Đơn hàng có bảo hiểm</span>
        </Checkbox>
        {value.enabled && (
          <InputNumber
            aria-label="Giá trị khai giá"
            disabled={disabled}
            style={{ flex: 1 }}
            min={0}
            max={MONEY_MAX}
            placeholder="Nhập giá trị"
            value={value.amount}
            status={missing ? 'error' : undefined}
            formatter={moneyFormatter}
            parser={moneyParser}
            onKeyDown={moneyInputKeyDownGuard}
            onChange={(amount) => onChange({ enabled: true, amount: amount ?? undefined })}
          />
        )}
      </div>
      {missing && (
        <div role="alert" style={{ color: '#ff4d4f', fontSize: 11 }}>
          Nhập giá trị khai giá hoặc bỏ chọn bảo hiểm
        </div>
      )}
    </div>
  );
}
